import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'
import { useHomeLink } from '~/hooks/useHomeLink'
import SVGImage from '~/components/Image/SVGImage'
import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'

export const Logo = ({
  className = 'h-10',
  white = false,
}: {
  className?: string
  white?: boolean
}): React.ReactElement => {
  const { t } = useTranslation(['imageAlt'])
  const logoRoute = useHomeLink()

  const handleLogoClick = (): void => {
    dashboardAnalytics.handleHeaderTopMenuClick('logo')
  }

  return (
    <Link to={logoRoute}>
      <SVGImage
        alt={t('imageAlt:icons.houseOfMath')}
        height={60}
        imageClassName={className}
        loading="eager"
        onClick={handleLogoClick}
        srcKey={white ? 'logos/house-of-math-white.svg' : 'logos/house-of-math.svg'}
        width={306}
      />
    </Link>
  )
}
